const airportGroupsUS = [
  {
    code: "NYC",
    name: "New York",
    airports: ["JFK", "LGA", "EWR"],
  },
  {
    code: "CHI",
    name: "Chicago",
    airports: ["ORD", "MDW"],
  },
  {
    code: "WAS",
    name: "Washington DC",
    airports: ["DCA", "IAD", "BWI"],
  },
  {
    code: "SFO",
    name: "San Francisco Bay Area",
    airports: ["SFO", "OAK", "SJC"],
  },
  {
    code: "LAX",
    name: "Los Angeles",
    airports: ["LAX"],
  },
  {
    code: "DAL",
    name: "Dallas",
    airports: ["DFW", "DAL"],
  },
  {
    code: "HOU",
    name: "Houston",
    airports: ["IAH", "HOU"],
  },
  {
    code: "MIA",
    name: "Miami",
    airports: ["MIA", "FLL"],
  },
];

export default airportGroupsUS;
